'use client';

import { usePathname } from '@/navigation';
import { useLocale } from 'next-intl';
import React from 'react';
import colorStyles from '@/styles/utils/variables.module.scss';
import { ButtonSizeType, CoursePage } from '@into-discovery/browsewebshared';
import { i18n } from '@/i18n-config';
import { ICourseProps } from '@/models/course/ICourseProps';
import { useApplyURL } from '@/hooks/use-apply-url';

type Props = {
  pageProps: ICourseProps;
};

export default function CourseDetailsProvider({ pageProps }: Props) {
  const locale = useLocale();
  const pagePath = usePathname();
  const brandURL = `/${locale}/universities/${pageProps?.content?.brand?.fields.slug}` as string;
  const applyURL = useApplyURL(pageProps?.data?.brandId, pageProps?.data?.id);
  const coursePageSettings = {
    applyURL,
    brandURL,
    buttonCopyColor: colorStyles.white,
    buttonSize: ButtonSizeType.Medium,
    backgroundColor: colorStyles.primary,
    hoverBackgroundColor: colorStyles.primaryHover,
    activeBackgroundColor: colorStyles.primaryActive,
    b2cFlag: true,
  };

  return (
    <CoursePage
      courseContent={pageProps?.content}
      courseData={pageProps?.data}
      coursePageSettings={coursePageSettings}
      courseInstance={pageProps?.instances}
      pagePath={pagePath}
      locales={i18n.locales}
      application={process.env.NEXT_PUBLIC_APPLICATION_NAME}
      googleTagId={process.env.NEXT_PUBLIC_GTM_CONTAINER_ID}
      iCasUndergraduateExists={pageProps?.iCasUndergraduateExists}
      iCasGraduateExists={pageProps?.iCasGraduateExists}
      currentLocale={locale}
    />
  );
}
